import { itemIsGroup } from './tree-type';
import memoizeOne from 'memoize-one';
export const findNodeInTree = memoizeOne((tree, search, are_filters_selected) => {
    const search_trim = search.trim();
    if (!search_trim && !are_filters_selected) {
        return tree;
    }
    const search_lower = search_trim.toLowerCase();
    return searchInDeviceTree(tree, search_lower, !!are_filters_selected);
});
//Убираем пробелы из строки поиска, если ищем серийники
export function searchInSerial(serial, search) {
    //Регулярное Выражение:\s - это regex для "пробел", и g является" глобальным " флагом, что означает match ALL \s (пробелы).
    return serial.toLowerCase().indexOf(search.replace(/\s+/g, ''));
}
function searchDevice(item, search) {
    return ('device' in item &&
        ((item.title && item.title.toLowerCase().indexOf(search) !== -1) ||
            (item.subtitle && item.subtitle.toLowerCase().indexOf(search) !== -1) ||
            (item.device.serial && searchInSerial(item.device.serial, search) !== -1) ||
            (item.device.id && item.device.id.toString().indexOf(search) !== -1) ||
            (item.device.individual_device_note &&
                item.device.individual_device_note
                    .toString()
                    .toLowerCase()
                    .indexOf(search) !== -1)));
}
export function searchInDeviceTree(tree, search, are_filters_selected) {
    return tree.flatMap((item) => {
        if (itemIsGroup(item)) {
            const newChildren = searchInDeviceTree(item.children, search, are_filters_selected);
            if (newChildren.length > 0) {
                return [{ ...item, children: newChildren, expanded: true }];
            }
        }
        else {
            if (searchDevice(item, search)) {
                return [item];
            }
        }
        return [];
    });
}
export function walkInCustomTree(part_of_tree, device_id, visible_index = 0) {
    //Пошли по пришедшему дереву, при первом вызове counter = 0
    const len = part_of_tree.length;
    for (let i = 0; i < len; i++) {
        const node = part_of_tree[i];
        //Если не группа (устройство) и совпадает с нашим, то надо выйти
        if (!itemIsGroup(node) && node.device.id === device_id)
            return { found_path: [i], visible_index };
        //Если какое-то устройство, то добавляем в счётчик, идём дальше
        visible_index++;
        if (itemIsGroup(node)) {
            //Группу надо поглядеть, вдруг там нужное нам устройство лежит
            const result = walkInCustomTree(node.children, device_id, visible_index);
            //Если группа не раскрыта
            if (!node.expanded) {
                // и мы там не нашли устройство, то надо идти дальше
                if (!result.found_path)
                    continue;
                // если нашли устройство, то надо вернуть индекс-1
                return {
                    found_path: [i, ...result.found_path],
                    visible_index: visible_index - 1,
                };
            }
            //Если нашли устройство в нераскрытой группе
            if (result.visible_index && result.found_path) {
                return {
                    found_path: [i, ...result.found_path],
                    visible_index: result.visible_index,
                };
            }
            // Иду дальше, в этой группе не было ничего
            visible_index = result.visible_index;
        }
    }
    return { visible_index };
}
/**
 * @function
 * Открываем папки по намеченному пути
 * @param tree - дерево устройств с папками
 * @param path - путь до нужного устройства
 * @return дерево с раскрытыми папками
 */
function openNeedFolderInDeviceTree(tree, path, is_first_render) {
    //Проверяю, что в пути ещё остались значения
    const path_index = path.length > 0 ? path[0] : null;
    //Если нет, то выхожу
    if (path_index == null) {
        return tree;
    }
    //Беру текущий элемент из этой группы в дереве
    const item = tree[path_index];
    //Если это группа, значит нужный нам элемент в ней или глубже
    if (itemIsGroup(item)) {
        //Получаю новых детей этой группы
        const new_children = openNeedFolderInDeviceTree(item.children, path.slice(1), is_first_render);
        //Открываю её и вставляю результат
        return [
            ...tree.slice(0, path_index),
            {
                ...item,
                expanded: is_first_render ? true : item.expanded,
                children: new_children,
            },
            ...tree.slice(path_index + 1),
        ];
    }
    //Если это не группа, то верни как есть
    return tree;
}
export function findSelectedDeviceInTree(tree, selected_device_id, is_first_render) {
    //Если никого не выбрали, то показываем первого
    if (selected_device_id == null) {
        return null;
    }
    const result = walkInCustomTree(tree, selected_device_id);
    if (result.found_path) {
        //Если нашли такого, то надо раскрыть дерево в нужных местах
        const tree_with_open_groups = openNeedFolderInDeviceTree(tree, result.found_path, is_first_render);
        //И опять пересчитать индексы
        const real_result = walkInCustomTree(tree_with_open_groups, selected_device_id);
        return {
            new_tree: tree_with_open_groups,
            visible_index: real_result.visible_index,
        };
    }
    return null;
}
